import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ExperiencePerformanceTypes } from '@atlassian/ufo-experimental';
import { FMP_MARK, INLINE_RESPONSE_MARK } from '@atlassian/ufo-experimental/types';
import { isInitialPageLoad } from '../utils/is-initial-page-load';
import { navigationMetrics } from './plugins/navigation-metrics';
import { appTimings } from './plugins/timings/app';
import { bundleEvalTimings } from './plugins/timings/bundle-eval';
import { resourceTimings } from './plugins/timings/resource';
var LoadMetricKeys = {
  tti: 'metric:tti',
  fmp: 'metric:fmp',
  ttiHistograms: 'metric:tti:histogramBuckets',
  fmpHistograms: 'metric:fmp:histogramBuckets'
};
var InlineResultMetricKeys = {
  result: 'metric:result',
  response: 'metric:response',
  resultHistograms: 'metric:result:histogramBuckets',
  responseHistograms: 'metric:response:histogramBuckets'
};
var CustomMetricKeys = {
  duration: 'metric:duration',
  durationHistograms: 'metric:duration:histogramBuckets'
};

var getHistogram = function getHistogram(data, performanceConfig, isInitial) {
  var _data$performanceConf, _ref, _ref2;

  var histogram = null;

  if ((_data$performanceConf = data.performanceConfig) !== null && _data$performanceConf !== void 0 && _data$performanceConf.histogram) {
    histogram = data.performanceConfig.histogram;
  } else if (performanceConfig !== null && performanceConfig !== void 0 && performanceConfig.histogram) {
    histogram = performanceConfig.histogram;
  }

  if (histogram) {
    var histograms = histogram[data.performanceType];

    switch (data.performanceType) {
      case ExperiencePerformanceTypes.PageLoad:
      case ExperiencePerformanceTypes.PageSegmentLoad:
        var histogramType = isInitial !== undefined && isInitial === true ? 'initial' : 'transition';
        return histograms ? (_ref = {}, _defineProperty(_ref, LoadMetricKeys.ttiHistograms, histograms[histogramType].tti), _defineProperty(_ref, LoadMetricKeys.fmpHistograms, histograms[histogramType].fmp), _ref) : {};

      case ExperiencePerformanceTypes.InlineResult:
        return histograms ? (_ref2 = {}, _defineProperty(_ref2, InlineResultMetricKeys.resultHistograms, histograms.result), _defineProperty(_ref2, InlineResultMetricKeys.responseHistograms, histograms.response), _ref2) : {};

      case ExperiencePerformanceTypes.Custom:
        return histograms ? _defineProperty({}, CustomMetricKeys.durationHistograms, histograms.duration) : {};
    }
  }
};

export var getLoadMetrics = function getLoadMetrics(data, ssr, performanceConfig) {
  var _data$metrics$marks$f, _objectSpread2;

  if (data.metrics.endTime === null || data.metrics.startTime === null) {
    return null;
  }

  var fmpMark = ((_data$metrics$marks$f = data.metrics.marks.find(function (mark) {
    return mark.name === FMP_MARK;
  })) === null || _data$metrics$marks$f === void 0 ? void 0 : _data$metrics$marks$f.time) || isInitialPageLoad(data) && (ssr === null || ssr === void 0 ? void 0 : ssr.getDoneMark());
  var tti = data.metrics.endTime - data.metrics.startTime;
  var fmp = typeof fmpMark === 'number' ? fmpMark - data.metrics.startTime : tti;
  return _objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, LoadMetricKeys.tti, Math.round(tti)), _defineProperty(_objectSpread2, LoadMetricKeys.fmp, Math.round(fmp)), _objectSpread2), getHistogram(data, performanceConfig));
};
export var getInlineResultMetrics = function getInlineResultMetrics(data, performanceConfig) {
  var _objectSpread3;

  if (data.metrics.endTime === null || data.metrics.startTime === null) {
    return null;
  }

  var responseMark = data.metrics.marks.find(function (mark) {
    return mark.name === INLINE_RESPONSE_MARK;
  });
  var result = data.metrics.endTime - data.metrics.startTime;
  var response = responseMark ? responseMark.time - data.metrics.startTime : result;
  return _objectSpread((_objectSpread3 = {}, _defineProperty(_objectSpread3, InlineResultMetricKeys.result, Math.round(result)), _defineProperty(_objectSpread3, InlineResultMetricKeys.response, Math.round(response)), _objectSpread3), getHistogram(data, performanceConfig));
};
export var getCustomMetrics = function getCustomMetrics(data, performanceConfig) {
  if (data.metrics.endTime === null || data.metrics.startTime === null) {
    return null;
  }

  var duration = data.metrics.endTime - data.metrics.startTime;
  return _objectSpread(_defineProperty({}, CustomMetricKeys.duration, Math.round(duration)), getHistogram(data, performanceConfig));
};

var getPerformanceMetrics = function getPerformanceMetrics(data, ssr, performanceConfig) {
  switch (data.performanceType) {
    case ExperiencePerformanceTypes.PageLoad:
    case ExperiencePerformanceTypes.PageSegmentLoad:
      return getLoadMetrics(data, ssr, performanceConfig);

    case ExperiencePerformanceTypes.InlineResult:
      return getInlineResultMetrics(data, performanceConfig);

    case ExperiencePerformanceTypes.Custom:
      return getCustomMetrics(data, performanceConfig);
  }
};

export var getPerformancePayload = function getPerformancePayload(data, ssr, bundleEvalConfig, resourceConfig, performanceConfig) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, getPerformanceMetrics(data, ssr, performanceConfig)), resourceTimings(data, resourceConfig)), bundleEvalTimings(data, bundleEvalConfig)), appTimings(data, ssr)), isInitialPageLoad(data) ? navigationMetrics() : null);
};